import { absolutePath } from "./absolutePath";

export const planTrials = {
  create: () => absolutePath("plan_trials"),
  destroy: () => absolutePath("plan_trials"),
};
